<template>
  <div class="im-container">
    <div class="nav">
      <div class="top">
        <van-sticky>
          <NavBar
            ref="navBar"
            :showRole="routeType === 'chat'"
            :goBack="goBack" 
            :title="routeType === 'chat' ? gameInfo.name.length > 6 ? gameInfo.name.slice(0,6)+'...' : gameInfo.name : this.$t('im.留言板')"
          >
          </NavBar>
        </van-sticky>
      </div>
      <Notice :top="noticeTop" ref="nav"/>
    </div>
    <div class="im-inner">
      <template>
        <router-view />
      </template>
    </div>
  </div>
</template>
<script>
  import {Notice} from '@/components/Notice';
  import ChangeRole from '@/views/modules/changeRole';

  export default {
    name: 'ImIndex',
    data () {
      return {
        routeType: 'msg',
        gameInfo: {}
        // isAutoLogin: !!sessionStorage.getItem('isAutoLogin')
      };
    },
    components: {Notice,ChangeRole},
    computed: {
      noticeTop() {
        let height= document.getElementsByClassName('top')[0] && document.getElementsByClassName('top')[0].offsetHeight || 88;
        return height;
      },
    },
    watch: {
      $route(to, from){
        this.setRouteInfo();
      }
    },
    created(){
    },
    mounted() {
      // this.initRole();
      try {
        this.gameInfo = JSON.parse(sessionStorage.getItem('gameInfo'));
      } catch (error) {
        
      }
      this.setRouteInfo();
    },
    methods: {
      setRouteInfo () {
        const { name } = this.$route;
        if (name === 'ImChat') {
          this.routeType = 'chat';
        } else {
          this.routeType = 'msg';
        }
      },
      goChat () {
        this.$router.push({
          name: 'ImChat'
        });
      },
      goBack () {
        this.$router.back();
      },
      goReportList () {
        const token = localStorage.getItem('token');
        if (!token) {
          const fullPath = this.$route.fullPath;
          this.$router.replace({
            name: 'Login',
            query: {
              redirect: fullPath
            }
          });
          return;
        }
        this.$router.push({
          name: 'ReportHistory'
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  /deep/ .van-dropdown-item{
    z-index: 100;
  }
  .im-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .nav {
      flex: 0 0 auto;
      .contact {
        display: flex;
        flex-direction: column;
        justify-content: center;
        white-space: normal;
        i {
          font-size: 20px;
        }
      }
      .history {
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
      }
    }
    .im-inner {
      flex: 1;
      overflow: hidden;
    }
  }
</style>
